import { useDisplayCurrency } from '~/composables/useDisplayCurrency'
import { createAustraliaMoneyFormatter } from '../utils/money'

export function useAustraliaDisplayCurrency() {
  const currency = useDisplayCurrency()
  return {
    ...currency,
    formatMoney: createAustraliaMoneyFormatter(currency.formatMoney),
    formatOriginalMoney: createAustraliaMoneyFormatter(currency.formatOriginalMoney),
  }
}
